import { TextDecorations, text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";

import Bold from "../../icons/bold.svg?react";
import BoldActive from "../../icons/bold-active.svg?react";
import { IsInPortrait } from "../../state/selectors";
import { CanApplyTextFormatting, MousedOverTextHelper } from "../../state/uiAtoms";
import { StyledTextControl } from "../StyledControl";
import { fireWrapSelectionEvent } from "../../lib/editor/events";

function BoldControl() {
	const setTextHelper = useSetRecoilState(MousedOverTextHelper);
	const isInPortrait = useRecoilValue(IsInPortrait);
	const canFormat = useRecoilValue(CanApplyTextFormatting);
	const handleClick = () => {
		if (!canFormat) return;
		fireWrapSelectionEvent(TextDecorations.bold);
	};

	const mouseOver = () => {
		setTextHelper(canFormat
			? text.textControls.bold
			: "Select text to apply bold");
	};

	const mouseLeave = () => {
		setTextHelper(undefined);
	};

	return (
		<>
			<StyledTextControl
				$dim={!canFormat}
				onClick={handleClick}
				onMouseOver={mouseOver}
				onMouseLeave={mouseLeave}
				aria-label={text.textControls.bold}
				aria-disabled={!canFormat}
				$isInPortrait={isInPortrait}
				$collapseMargin
				data-testid="bold-control"
			>
				{canFormat ? (
					<BoldActive aria-hidden="true" focusable="false" className="format-text-control bold" />
				) : (
					<Bold aria-hidden="true" focusable="false" className="format-text-control bold" />
				)}
			</StyledTextControl>
		</>
	);
}

export default BoldControl;
